export const SEND_REWARD = "SEND_REWARD";
export const GET_REWARD_HISTORY = "GET_REWARD_HISTORY";

export const GET_USER_FRAMES = "GET_USER_FRAMES";
export const GET_USER_SVGAS = "GET_USER_SVGAS";
export const GET_USER_BACKGROUNDS = "GET_USER_BACKGROUNDS";
export const GET_USER_GIFTS = "GET_USER_GIFTS";
export const GET_USER_INVENTORY_HISTORY = "GET_USER_INVENTORY_HISTORY";
